/**
 * alertLevelsHelper.js
 * Created by michaelbray on 2/13/18.
 */

export const INFO_ALERT_LEVEL = 'INFO';
export const WARNING_ALERT_LEVEL = 'WARNING';
export const SUCCESS_ALERT_LEVEL = 'SUCCESS';
export const ERROR_ALERT_LEVEL = 'ERROR';
